exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".LoadingModal__LoadingModal__7o8_G {\n  z-index: 1000;\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: #F1F3F4; }\n  .LoadingModal__LoadingModal__box__3Ajtp {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n    width: 100px;\n    height: 100px;\n    background-color: #F8F9FA;\n    border-radius: 10px;\n    margin: 8em auto 0; }\n", ""]);

// exports
exports.locals = {
	"LoadingModal": "LoadingModal__LoadingModal__7o8_G",
	"LoadingModal__box": "LoadingModal__LoadingModal__box__3Ajtp"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/circleci/project/src/styles"]}!./src/app/nest/components/LoadingModal/LoadingModal.scss
// module id = 464
// module chunks = 0